<template>
  <svg
    width="21"
    height="18"
    viewBox="0 0 21 18"
  >
    <path d="M11.0665 1.57961L10.2458 2.40211L9.42254 1.57886C7.32347 -0.520204 3.92021 -0.520204 1.82114 1.57886C-0.277926 3.67793 -0.277926 7.08119 1.82114 9.18026L9.71651 17.0756C10.0094 17.3685 10.4843 17.3685 10.7772 17.0756L18.6786 9.1788C20.773 7.07277 20.7766 3.67906 18.6772 1.57961C16.5743 -0.523282 13.1694 -0.523279 11.0665 1.57961ZM17.615 8.12108L10.2468 15.4846L2.8818 8.1196C1.36852 6.60632 1.36852 4.15281 2.8818 2.63952C4.39508 1.12624 6.8486 1.12624 8.36188 2.63952L9.71933 3.99697C10.0172 4.29483 10.5019 4.28903 10.7925 3.98412L12.1272 2.64027C13.6443 1.12317 16.0994 1.12316 17.6165 2.64027C19.1302 4.15391 19.1276 6.60015 17.615 8.12108Z" />
  </svg>
</template>
